define([
    'text!index2021-cooperate/component/page-content.html',
    'index2021-cooperate/api',
    'lodash',
    'jquery',
    'index2021-cooperate/component/cooperate-item',
    'index2021-cooperate/component/cooperate-item-phone',
    'web/common/utils'
], function(
    tpl,
    Api,
    _,
    $,
    CooperateItem,
    CooperateItemPhone,
    Utils
){
    var items = [
        { title: '项目批量采购', desc: '', type: 1, class: 'project'},
        { title: '设计公司合作', desc: '', type: 2, class: 'desgin'},
        { title: '家居品牌合作', desc: '', type: 3, class: 'grocery'},
        { title: '市场&媒体合作', desc: '', type: 4, class: 'marketing'},
        { title: '艺术品合作', desc: '', type: 5, class: 'gallery'}
    ];
    return {
        template: tpl,
        components: {
            CooperateItem: CooperateItem,
            CooperateItemPhone: CooperateItemPhone
        },
        data: function(){
            return {
                isPC: true,
                items: []
            };
        },
        methods: {
            init: function(){
                var _this = this;
                if($(window).width()<=750){
                    _this.isPC = false;
                    $('.fixed-menu').css({display: 'none'});
                }else {
                    _this.isPC = true;
                }
                if(_this.$i18n.locale=='en'){
                    _this.items = _this.$i18n.messages.en.cooperateItem;
                }else {
                    _this.items = _this.$i18n.messages.zh.cooperateItem;
                }
                _this.fetchCooperateCfg();
            },
            fetchCooperateCfg: function(){
                var _this = this;
                Api.getCooperateCfgApi.ajax()
                    .done(function(data){
                        _.forEach(_this.items, function(o){
                            o.desc = data[o.class+'Info'];
                        });
                        Utils.emitPageReady();
                    });
            },
            toScroll: function () {
                // var scrollTop = $(window).scrollTop();
                // if(scrollTop>=180){
                //     $(".index2021-cooperate-t").css({position:'fixed',top:0,left:0,'z-index':10});
                // }else {
                //     $(".index2021-cooperate-t").css({position:'relative'});
                // }
            }
        },
        watch: {
            '$i18n.locale': function () {
                this.init();
            }
        },
        created: function(){
            this.fetchCooperateCfg();
        },
        mounted: function() {
            this.init();
            var obj = this;
            $(window).resize( function  () {           //当浏览器大小变化时
                if(($(window).width()<=750&&obj.isPC)||($(window).width()>750&&!obj.isPC)){
                    window.location.reload();
                }
            });
            $(window).scroll(function () {
                obj.toScroll();
            });
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./index2021-cooperate/component/page-content.js
// module id = 200
// module chunks = 0